import { useWallet, WalletStatus } from "@terra-money/wallet-provider";
import { toTerraAmount } from "functions/toXAmount";
import useAddress from "hooks/useAddress";
import { useBalance, useChainAddress } from "state/global";
import { useLocation } from "react-router-dom";
import {
    Menu,
    MenuButton,
    MenuList,
  } from '@chakra-ui/react'
  import { uMap } from "constants/constants";
import st_wallet from "./WalletButton.module.css";
import { sliced } from "functions/sliceAddress";

const ConnectedButton = () => {
    const { disconnect, connection, status } = useWallet();
    const location = useLocation();

    const user_address = useAddress();
    const [eth_address] = useChainAddress("address");
    const [network] = useChainAddress("network");
    const [uusd_balance] = useBalance("uusd");
    const [uluna_balance] = useBalance("uluna");
    const [eth_balance] = useBalance("eth");
    const [bnb_balance] = useBalance("bnb");
    
    const Currency = ({ denom }: { denom: string }) => {
        const presentable = uMap.get(denom);

        const balance = 
        denom === "uusd" ? uusd_balance :
        denom === "uluna" ? uluna_balance :
        network.includes("bnb") ? bnb_balance :
        eth_balance;

        return (
            <div className={st_wallet.currency}>
                <img src={`/images/tokens/${presentable}.png`}/>
                <h5>{toTerraAmount(balance).toFixed(3)} {presentable}</h5>
            </div>
        )
    }

    return (
        <Menu matchWidth flip>
            <MenuButton className={location.pathname === "/" ? 
            st_wallet.home_wallet_button : st_wallet.charity_wallet_button}>
                {sliced(user_address || eth_address, 5, -3)} 
                &nbsp;|&nbsp; 
                {status === WalletStatus.WALLET_CONNECTED && toTerraAmount(uusd_balance).toFixed(3) + " UST"}
                {status !== WalletStatus.WALLET_CONNECTED && 
                toTerraAmount(network.includes("bnb") ? bnb_balance : eth_balance).toFixed(3) 
                + (network.includes("bnb") ? " BNB" : " ETH")}
            </MenuButton>
            <MenuList className={st_wallet.menu_list}>
                <div className={st_wallet.info}>
                    <h1 className={st_wallet.type}>
                        Wallet: <span>
                                {connection?.name.replace(" Wallet", "") ?? 
                                (network.includes("bnb") ? "Binance" :  "MetaMask")
                                }
                            </span>
                    </h1>
                </div>
                <hr/>
                <h3 className={st_wallet.title}>Balance</h3>
                {status === WalletStatus.WALLET_CONNECTED && <Currency denom="uluna"/>}
                {status === WalletStatus.WALLET_CONNECTED && <Currency denom="uusd"/>}
                <Currency denom={`${network.includes("bnb") ? "bnb" : "eth"}`}/>
                <button 
                className={st_wallet.disconnect}
                onClick={() => status === WalletStatus.WALLET_CONNECTED ? 
                disconnect() : window.location.reload() }>
                    Disconnect
                </button>
            </MenuList>
        </Menu>
    )
}

export default ConnectedButton;